export default __webpack_public_path__ + "static/media/testPart3.02ef7be2.svg";